export const GET_WATCHES_REQUEST = "get-watches-request";
export const GET_WATCHES_SUCCESS = "get-watches-success";
export const GET_WATCHES_ERROR = "get-watches-error";
